import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import Button from '../common/Button'; // Importando o botão genérico

const ProfileForm = ({
  nome,
  email,
  cpf,
  titulo,
  photoURL,
  loading,
  message,
  setNome,
  setEmail,
  setCpf,
  setTitulo,
  setShowProfessionalTab,
  handleFileChange,
  handleUpdateProfile,
}) => (
  <form onSubmit={handleUpdateProfile} className="flex flex-col gap-4">
    <div className="flex flex-col items-center">
      <img
        src={photoURL || 'https://via.placeholder.com/80?text=80x80'}
        alt="Foto do perfil"
        className="w-20 h-20 rounded-full border-4 border-teal-600 shadow-md"
      />
      <label
        htmlFor="file-upload"
        className="mt-2 cursor-pointer bg-teal-600 text-white p-2 rounded-full hover:bg-teal-700 focus:bg-teal-700 active:bg-teal-800"
      >
        <input
          id="file-upload"
          type="file"
          accept="image/jpeg, image/png"
          onChange={handleFileChange}
          className="hidden"
        />
      </label>
    </div>

    <div className="input-group">
      <label htmlFor="titulo" className="text-gray-700">
        Título:
      </label>
      <select
        id="titulo"
        name="titulo"
        value={titulo}
        onChange={(e) => {
          setTitulo(e.target.value);
          setShowProfessionalTab(
            e.target.value === 'Dr.' || e.target.value === 'Dra.'
          );
        }}
        disabled={loading}
        className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
      >
        <option value="" disabled>
          Selecione um título
        </option>
        <option value="Outros">Outros</option>
        <option value="Dr.">Dr.</option>
        <option value="Dra.">Dra.</option>
      </select>
    </div>

    <div className="input-group">
      <label htmlFor="nome" className="text-gray-700">
        Nome Completo:
      </label>
      <input
        type="text"
        id="nome"
        name="nome"
        placeholder="Digite seu nome e sobrenome"
        value={nome}
        onChange={(e) => setNome(e.target.value)}
        required
        disabled={loading}
        className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
      />
    </div>

    <div className="input-group">
      <label htmlFor="email" className="text-gray-700">
        Email:
      </label>
      <input
        type="email"
        id="email"
        name="email"
        placeholder="Digite seu email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        disabled={loading}
        className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
      />
    </div>

    <div className="input-group">
      <label htmlFor="cpf" className="text-gray-700">
        CPF:
      </label>
      <InputMask
        mask="999.999.999-99"
        type="text"
        id="cpf"
        name="cpf"
        placeholder="000.000.000-00"
        value={cpf}
        onChange={(e) => setCpf(e.target.value)}
        required
        disabled={loading}
        className="w-full p-2 border border-gray-300 rounded-lg focus:border-teal-600 focus:ring-teal-600"
      />
    </div>

    {/* Substituindo o botão de "Salvar Alterações" pelo botão genérico */}
    <Button
      type="salvar"
      label={loading ? 'Salvando...' : 'Salvar Alterações'}
      onClick={handleUpdateProfile}
      className=""
      disabled={loading}
    />

    {message && (
      <div className="text-teal-600 font-semibold mt-4">{message}</div>
    )}
  </form>
);

// Definindo propTypes para validação
ProfileForm.propTypes = {
  nome: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  cpf: PropTypes.string.isRequired,
  titulo: PropTypes.string.isRequired,
  photoURL: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  message: PropTypes.string,
  setNome: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  setCpf: PropTypes.func.isRequired,
  setTitulo: PropTypes.func.isRequired,
  setShowProfessionalTab: PropTypes.func.isRequired,
  handleFileChange: PropTypes.func.isRequired,
  handleUpdateProfile: PropTypes.func.isRequired,
};

export default ProfileForm;
